import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
} from "@mui/material";
import { createContext, useEffect, useState } from "react";
import { Pricing } from "../pricingListSlice";
import { json } from "stream/consumers";
import { ErrorField } from "../../../common/components/ErrorField";
import { PrimaryButton } from "../../../common/components/CustomButton";

export const ErrorByPartiesModalContext = createContext<{
	pricing: Pricing | null;
	setPricing: (pricing: Pricing | null) => void;
}>({
	pricing: null,
	setPricing: () => {},
});

export function ErrorByPartiesModal(props: React.PropsWithChildren<{}>) {
	const [pricing, setPricing] = useState<Pricing | null>(null);

	return (
		<>
			<ErrorByPartiesModalContext.Provider
				value={{ pricing, setPricing }}
			>
				{props.children}
			</ErrorByPartiesModalContext.Provider>
			<Dialog
				PaperProps={{ style: { minHeight: "28%" } }}
				sx={{ "& .MuiDialog-paper": { minWidth: "50%" } }}
				open={!!pricing}
				onClose={() => setPricing(null)}
			>
				<DialogTitle>Booking Errors</DialogTitle>
				<DialogContent>
					{pricing?.parties?.map((pricingParty) => (
						<>
							<Typography
								key={pricingParty.id}
								variant="subtitle1"
							>
								{pricingParty.party.name}
							</Typography>
							<ErrorField error={pricingParty.booking_outputs} />
						</>
					))}
				</DialogContent>
				<DialogActions>
					<PrimaryButton
						onClick={() => setPricing(null)}
						text="Close"
						type="button"
						color="primary"
					></PrimaryButton>
				</DialogActions>
			</Dialog>
		</>
	);
}
